import type { TextProps } from '@features/powerpoint';
import { parseTags } from '@features/powerpoint';
import { themeV2 } from './theme-v2';
import { DEFAULT_FONT } from '../utils/constants-v2';

export const NEWLINE_REGEX = /\r?\n/;

export const convertMarkdownBoldToTags = (text: string): string =>
  text.replaceAll(/\*\*(.+?)\*\*/g, '<b>$1</b>');

export const formatAiInsightSummary = (summary: string[]): string =>
  convertMarkdownBoldToTags(summary.join('\n'));

const EXCLUDED_AI_INSIGHT_PREFIXES = ['Unlock potential gains'];

export const formatOverallAiInsightSummary = (summary: string[]): string =>
  formatAiInsightSummary(
    summary.filter(
      line =>
        !EXCLUDED_AI_INSIGHT_PREFIXES.some(prefix => line.startsWith(prefix))
    )
  );

export const splitKeyTakeaways = (text: string): string[] =>
  text
    .split(NEWLINE_REGEX)
    .map(line => line.replaceAll(/<.*?>/g, '').trim())
    .filter(line => line !== '');

export const parsedTakeawaysV2 = (keyTakeaways: string[]): TextProps['text'] =>
  keyTakeaways.flatMap(takeaway => {
    if (takeaway.length === 0) {
      return [];
    }

    const parsedContent = parseTags(takeaway);

    return parsedContent.map((textProps, index) => ({
      ...textProps,
      options: {
        color: themeV2.colors.metricBlue,
        fontFace: DEFAULT_FONT,
        ...textProps.options,
        ...(index === 0 ? { bullet: true } : {}),
        ...(index === parsedContent.length - 1 ? { breakLine: true } : {}),
      },
    }));
  });
